import {NEWS} from "../../constants/news";

export function fetchNews(params) {
  return {
    type: NEWS.FETCH_NEWS.MAIN,
    params
  }
}

